/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { DeleteIcon, StorefrontAddIcon } from "../../../../assets/svgIcons";
import secondaryComponents from "../..";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";

const AddCustomerSection = ({
  customerDetails,
  showAddCustomer = true,
  setCustomerDetails = () => {},
}) => {
  const [isAddCustomer, setIsAddCustomer] = useState(false);

  const addCustomer = ({
    customer_id,
    customer_phone_number,
    customer_full_name,
    customer_email,
    customer_phone_code,
    ...rest
  }) => {
    setCustomerDetails({
      customerId: customer_id,
      customerPhoneNumber: customer_phone_number,
      customerEmail: customer_email,
      customerName: customer_full_name,
      customerPhoneCode: customer_phone_code,
      ...rest,
    });
  };

  return (
    <>
      <div className={globalStyles.cardWithBorder}>
        <div className="d-flex justify-content-between mb-3">
          <h5 className="mb-0">Select Existing Users Here</h5>
          {showAddCustomer ? (
            <a
              className="d-flex align-items-center cursor-pointer"
              onClick={() => setIsAddCustomer(true)}
              style={{ gap: "5px" }}
            >
              <StorefrontAddIcon width="18" height="18" />
              <p className="purple--text smallest-text-size">
                Add new customer
              </p>
            </a>
          ) : null}
        </div>
        <secondaryComponents.CustomersSearchField
          setCustomerDetails={addCustomer}
          phone={"customerPhoneNumber"}
          email
          title={"updateCustomerOrderDetails"}
        />

        {customerDetails?.customerName ? (
          <>
            <hr />

            <div
              className="d-flex flex-wrap justify-content-between"
              style={{ gap: "15px" }}
            >
              <h6 className="mb-0">{customerDetails?.customerName}</h6>
              <div
                className="d-flex align-items-center ml-auto"
                style={{ gap: "10px" }}
              >
                <div className="text-right">
                  <h6 className="mb-0 smallest-text-szie">
                    {customerDetails?.customerPhoneNumber !== ""
                      ? customerDetails?.customerPhoneCode
                      : ""}{" "}
                    {customerDetails?.customerPhoneNumber}
                  </h6>
                  <p className="smallest-text-szie mb-0">
                    {customerDetails?.customerEmail}
                  </p>
                </div>
                <span
                  onClick={() => {
                    setCustomerDetails((prev) => ({
                      ...prev,
                      customerPhoneNumber: "",
                      customerEmail: "",
                      customerName: "",
                    }));
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <DeleteIcon />
                </span>
              </div>
            </div>
          </>
        ) : null}
      </div>

      <secondaryComponents.Modal
        closeModal={() => setIsAddCustomer(false)}
        isActive={isAddCustomer}
        width={500}
      >
        <secondaryComponents.AddCustomer
          closeModal={() => setIsAddCustomer(false)}
          addCustomer={addCustomer}
        />
      </secondaryComponents.Modal>
    </>
  );
};
export default AddCustomerSection;
